export const DESTINATION_INITIAL_STATE = {
    filter: {
        name: '',
        show: 'active',
    },
    createDestinationInitial: {
        name: '',
        active: true,
        feedLotId: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: 'US',
        postalCode: '',
        coordinates: '',
        contactNumber: '',
        altContactNumber: '',
        email: '',
        altEmail: '',
        contactName: '',
    },
    loader: true,
};
